import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const XAppInterceptor: HttpInterceptorFn = (req, next) => {
  let emptyGuid = '00000000-0000-0000-0000-000000000000';

  // Use only languageGuid key, fallback to default English GUID
  const languageGuid = localStorage.getItem('languageGuid') ?? '24c9b00d-d028-4e04-a1aa-f04d2dcae2c3';

  // if (req.url.includes('tilecache.rainviewe')) {
  //   return next(req);
  // }

  const isCsiDomain = location.hostname.includes('sustainability.doktar');

  // Bypass Angular service worker for notification/SignalR HTTP calls. The SW proxies all
  // HttpClient traffic and can return 504 on soft refresh when negotiate runs during startup.
  const shouldBypassSw =
    req.url.includes('notification.doktar.') || req.url.includes('.service.signalr.net');

  let headers = req.headers
    .set('X-App', !isCsiDomain ? environment.appId : environment.appId_csi)
    .set('X-Enterprise', localStorage.getItem('enterpriseId') ?? emptyGuid)
    .set('X-Auth-Token', 'Bearer ' + (localStorage.getItem('token') ?? ''))
    .set('X-Locale', languageGuid);

  if (shouldBypassSw) {
    headers = headers.set('ngsw-bypass', 'true');
  }

  const modifiedRequest = req.clone({ headers });
  return next(modifiedRequest);
};
